/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_Q3Inputs */

const en_fw_faq_q3 = /** @type {(inputs: Fw_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Firefly Wedding based on a manga?`)
};

const zh_fw_faq_q3 = /** @type {(inputs: Fw_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁有原作漫画吗？`)
};

/**
* | output |
* | --- |
* | "Is Firefly Wedding based on a manga?" |
*
* @param {Fw_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_q3 = /** @type {((inputs?: Fw_Faq_Q3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_Q3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_q3(inputs)
	return zh_fw_faq_q3(inputs)
});
export { fw_faq_q3 as "fw.faq.q3" }